import React from 'react';
import { TrendingUp, Target, Rocket, Users, Megaphone, LineChart, Zap } from 'lucide-react';
import { ServicePage } from '../components/ServicePage';
export function SaaSGrowth() {
  return <ServicePage badgeText="SAAS GROWTH ENABLEMENT" badgeIcon={<TrendingUp className="w-3.5 h-3.5" data-id="element-557" />} titleStart="Grow faster," titleAccent="retain longer" titleAccentColor="green" subtitle="We help SaaS companies turn product-led growth into revenue. From activation funnels to retention loops, we build the systems that scale." heroIcon={TrendingUp} heroIconColor="text-green-600" heroIconBg="bg-green-50" checklist={['Activation & onboarding flows', 'Retention & lifecycle ops', 'Go-to-market strategy', 'Pricing & packaging']} features={[{
    title: 'Growth Strategy',
    description: 'Data-driven roadmaps to identify and unlock your highest-leverage growth opportunities.',
    icon: Target
  }, {
    title: 'Onboarding & Activation',
    description: 'Onboarding flows that turn signups into active, paying customers in record time.',
    icon: Rocket
  }, {
    title: 'Retention Systems',
    description: 'Lifecycle automations and engagement loops that reduce churn and drive expansion.',
    icon: Users
  }, {
    title: 'Demand Generation',
    description: 'Inbound, content, and paid programs that fill your pipeline with qualified leads.',
    icon: Megaphone
  }, {
    title: 'Revenue Operations',
    description: 'Stack, processes, and reporting to keep marketing, sales, and CS in lockstep.',
    icon: LineChart
  }, {
    title: 'PLG Motions',
    description: 'Self-serve experiments, in-product CTAs, and frictionless upgrade paths.',
    icon: Zap
  }]} processSteps={[{
    number: '01',
    title: 'Audit',
    description: 'Deep-dive into your funnel, metrics, and current growth motions.'
  }, {
    number: '02',
    title: 'Roadmap',
    description: 'A prioritized 90-day plan with clear hypotheses and success metrics.'
  }, {
    number: '03',
    title: 'Execute',
    description: 'Our team runs experiments and ships growth work weekly.'
  }, {
    number: '04',
    title: 'Scale',
    description: 'Double down on what works and build repeatable growth systems.'
  }]} ctaTitle="Ready to unlock your next stage of growth?" ctaSubtitle="Talk to our SaaS growth team and get a free 30-minute audit." data-id="element-556" />;
}